
namespace RioERP.Reports {
    export class OrderShippingItemsReportColumns {
        static columnsKey = 'Reports.OrderShippingItemsReport';
    }
}